import { get, put, post } from "./api_helper"

export const getImageList = () => get(`admin/master/rtw-image/list`)

// export const addSheet = datas =>
//   post(
//     `admin/master/order-sheet/creation/${datas.id}/handwriting`,
//     datas.formData
//   )
